import RedotpayCard from "@/components/RedotpayCard";
import RpIcon from "@/components/RpIcon";
import { CARD_TYPE } from "@/constant/Constant.ts";
import CardCancelDialog from "@/pages/card/components/CardCancelDialog";
import CardLabelDialog from "@/pages/card/components/CardLabelDialog/CardLabelDialog";
import CardPinDialog from "@/pages/card/components/CardPinDialog/CardPinDialog.tsx";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import BillAddressDialog from "@/pages/user/components/BillAddressDialog";
import ReportLostModal from "@/pages/user/components/ReportLostModal";
import { getCardDetail } from "@/services";
import { getUrlParams } from "@/utils/utils";
import {
  Box,
  Divider,
  Stack,
  Typography,
  useTheme
} from "@mui/material";
import { useBoolean, useRequest, useSize } from "ahooks";
import {useEffect, useMemo, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, createSearchParams, useSearchParams } from "react-router-dom";
import classes from "./Index.module.css";
import {enqueueSnackbar} from "notistack";
import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";

import useUrlState from '@ahooksjs/use-url-state';

const ModifyCard = (props: any) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme()
  const {t} = useTranslation();
  const {settings} = useSettings();
  const navigate = useNavigate();
  const ref = useRef(null)
  const size = useSize(document.querySelector('body'));
  const {state} = location;
  // const {card} = state;
  const cardId = getUrlParams("cardId");
  const [cardNumber, setCardNumber] = useState("2343 2343 6576 8888");
  const [isHide, setHide] = useState(true);
  const [urlstate, seturlstate] = useUrlState({});

  const paramCard = useMemo(() => {
    let ret: any = Object.fromEntries(searchParams)
    return ret
  }, [searchParams])


  // const displayedCardNumber = useMemo(() => {
  //   if (isHide) {
  //     return cardNumber.replace(/\d/g, "*");
  //   }
  //   return cardNumber;
  // }, [isHide]);

  const [isCardlabelModalOpen, cardlabelModalOperate] = useBoolean(false);
  const [isCardPinModalOpen, cardPinModalOperate] = useBoolean(false);
  const [billAddressOpen, billAddressOpenOperate] = useBoolean(false);
  const [cancalCardOpen, cancalCardOpenOperate] = useBoolean(false);
  const [reportLostCardOpen, reportLostCardOpenOperate] = useBoolean(false);
  const getCardDetailReq = useRequest(async () => {
      const res = await getCardDetail(cardId)
      return res as any
  }, { manual: true })

  useEffect(() => {
    // console.log('监听paramCard',paramCard)
    if (paramCard.hasOwnProperty('lossStatus') && paramCard.lossStatus < 1) {
      getCardDetailReq.runAsync()
    }
  }, [paramCard]);


  const cardScale = useMemo(() => {
    const scale = size?.width / 375
    return scale
  }, [size])
  const onGotoChargingRules = () => {
    switch (settings.lang) {
      case 'hk':
        window.location.href = 'https://support.redotpay.com/hc/zh-hk/articles/8175806281103-RedotPay%E5%8D%A1%E7%9A%84%E9%99%90%E5%88%B6%E5%92%8C%E8%B4%B9%E7%8E%87'
        break
      default:
        window.location.href = 'https://support.redotpay.com/hc/en-us/articles/8175806281103-RedotPay-card-limitations-fees', '_blank'
        break
    }
  }

  const cardDetail = useMemo(() => {
    if (!getCardDetailReq?.data) {
      return paramCard
    }
    return getCardDetailReq?.data
  }, [getCardDetailReq?.data, paramCard])

  return (
    <>
      <Stack className={classes.root}>
        <SimpleHeader title={t('card_management')}/>
        <Stack className={classes.content}>
          <Box direction="column" className={classes.card}>
            <Box className={classes.cardDetail}
                 sx={theme => {
                   return {
                     overflow: 'visible',
                     // width: theme.typography.pxToRem(343), //'343px',
                     height: 201 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
                     maxHeight: 201 * (520 / 375) + 'px'
                   }
                 }}
            >
              <RedotpayCard cardItem={cardDetail}/>
            </Box>
            <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '4px', marginTop:'16px'}} />
            <Box
              className={`${classes.group} ${classes.radius}`}
            >
              <Stack
                onClick={() => {
                  cardlabelModalOperate.setTrue();
                }}
                direction="row"
                className={`${classes.row} ${classes.radius}`}
              >
                <Typography>{t("card_tag")}</Typography>
                <Stack direction="row" className={classes.right}>
                  <Typography>{cardDetail?.label}</Typography>
                  <RpIcon
                    icon="arrow-right-simple"
                  />
                </Stack>
              </Stack>
            </Box>
            <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '4px' }} />
            <Box
              className={`${classes.group} ${classes.radius}`}
            >
              <Stack
                onClick={() => {
                  navigate({
                    pathname: `${RouteConstant.CARD_PAYMENT_CURRENCY_SETTINGS}`,
                    search: `?${createSearchParams({ cardId: cardId })}`
                  })
                }}
                direction="row" className={classes.row}>
                <Typography>{t("payment_currency_settings")}</Typography>
                <RpIcon icon="arrow-right-simple"/>
              </Stack>
              <Stack
                onClick={() => {
                  billAddressOpenOperate.setTrue();
                }}
                direction="row" className={classes.row}>
                <Typography>{t("edit_billing_address")}</Typography>
                <RpIcon icon="arrow-right-simple"/>
              </Stack>
              <Stack
                onClick={() => {
                  onGotoChargingRules()
                }}
                direction="row" className={classes.row}>
                <Typography>{t("charging_rules")}</Typography>
                <RpIcon icon="arrow-right-simple"/>
              </Stack>
              {/* {cardDetail?.cardType != CARD_TYPE.CARD_TYPE_PHYSICAL && cardDetail.lossStatus != 1 && (<Stack
                onClick={() => {
                  navigate({
                    pathname: `${RouteConstant.CARD_REISSUE}`,
                    search: `?${createSearchParams({ cardId: cardId })}`
                  })
                }}
                direction="row" className={classes.row}>
                <Typography>{t("reissue_card")}</Typography>
                <RpIcon icon="arrow-right-simple"/>
              </Stack> ) } */}
              {cardDetail?.cardType == CARD_TYPE.CARD_TYPE_PHYSICAL && (
                <Stack
                  onClick={() => {
                    cardPinModalOperate.setTrue();
                  }}
                  direction="row" className={classes.row}>
                  {getCardDetailReq?.data?.pinSet ?
                    <Typography>{t('update_card_pin')}</Typography>
                    : <Typography>{t('set_card_pin')}</Typography>
                  }
                  <RpIcon icon="arrow-right-simple" />
                </Stack>
              )}
              {cardDetail?.cardType == CARD_TYPE.CARD_TYPE_PHYSICAL && (
                <Stack
                  onClick={() => {
                    if (cardDetail.lossStatus >= 1) {
                      return
                    }
                    reportLostCardOpenOperate.setTrue();
                  }}
                  direction="row" className={classes.row}>
                  <Typography>{t('report_lost')}</Typography>
                  {cardDetail.lossStatus >= 1 ?
                    <span style={{fontSize: '16px', color: theme.palette.text.secondary}}>{t('card_is_loss')}</span> :
                    <Stack direction="row" alignItems="center">
                      <span style={{fontSize: '16px', color: theme.palette.brand.main}}>{t('loss_card')}</span>
                      <RpIcon icon="arrow-right-simple" color={theme.palette.brand.main} />
                    </Stack>
                    // <RpIcon icon="arrow-right-simple" />
                  }
                </Stack>
              )}
            </Box>
            <Divider sx={{borderColor: theme.palette.background.paper, borderWidth: '4px' }} />
            <Box
              className={`${classes.group} ${classes.radius}`}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                className={`${classes.row} ${classes.radius}`}
                onClick={() => {
                  let __searchParams = {
                    ...Object.fromEntries(searchParams),
                    // from: 'guide'
                  }
                  navigate({
                    pathname: `${RouteConstant.CARD_DELETE}`,
                    search: createSearchParams(__searchParams).toString()
                      //`?${createSearchParams({ cardId: cardId })}`
                  })
                  // cancalCardOpenOperate.setTrue();
                }}
              >
                <Typography
                  sx={(theme) => {
                    // return {color: theme.palette.warning.main};
                  }}
                  className={classes.cancalCard}
                >
                  {t("delete_card")}
                </Typography>
                <Typography
                  sx={(theme) => {
                    return {
                      color: theme.palette.brand.main,
                      fontSize: '16px'
                    };
                  }}
                >{t('delete_out')}</Typography>
              </Stack>
            </Box>
          </Box>
        </Stack>
      </Stack>
      <CardLabelDialog
        open={isCardlabelModalOpen}
        onClose={() => {
          cardlabelModalOperate.setFalse();
        }}
        onConfirm={()=>{
          getCardDetailReq.runAsync()
        }}
        card={{...getCardDetailReq?.data, cardId: cardId}}
      ></CardLabelDialog>
      <CardPinDialog
        open={isCardPinModalOpen}
        onClose={() => {
          cardPinModalOperate.setFalse();
        }}
        card={{cardId: cardId, ...getCardDetailReq?.data}}
      >
        <Box></Box>
      </CardPinDialog>
      <BillAddressDialog
        cardId={cardId}
        open={billAddressOpen}
        onClose={() => {
          billAddressOpenOperate.setFalse();
        }}
      />
      <CardCancelDialog
        card={cardDetail}
        open={cancalCardOpen}
        onClose={cancalCardOpenOperate.setFalse}
      />
      <ReportLostModal
        card={cardDetail}
        open={reportLostCardOpen}
        onClose={reportLostCardOpenOperate.setFalse}
      />
    </>
  );
};

export default ModifyCard;
